<template>
 <content-loader
    viewBox="0 0 950 620"
    :speed="1"
    primaryColor="#f3f3f3"
    secondaryColor="#cfcfcf"
  >
    <rect x="0" y="0" rx="0" ry="0" width="950" height="620" /> 
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
export default {
  components: {
    ContentLoader,
  },
};
</script>